// extracted by mini-css-extract-plugin
module.exports = {"callToClick":"styles_callToClick__bMrbc","specificTable":"styles_specificTable__YP1r5"};